<template>
  <div class="adt_modal-outer" v-show="isOpen">
    <transition name="slide">
      <div class="adt_modal" v-show="isOpen">
        <div class="adt_modal-close">
          <slot name="badge"></slot>
          <i class="fas fa-times fa-lg close-button" @click="toggle"></i>
        </div>
        <div class="adt_modal-header">
          <h3 class="adt_heading-4" v-if="title">{{ title }}</h3>
          <p v-if="creationDate">{{ creationDate }}</p>
        </div>
        <hr />
        <div class="adt_modal-button">
          <slot name="button"></slot>
        </div>
        <div class="adt_modal-content">
          <div class="grey-box">
            <slot name="content"></slot>
          </div>
        </div>
        <div class="adt_modal-footer">
          <slot name="footer"></slot>
        </div></div
    ></transition>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isOpen: false,
    };
  },
  props: ["title", "creationDate"],
  methods: {
    toggle() {
      this.isOpen = !this.isOpen;
    },
  },
  watch: {
    isOpen: function (val) {
      if (!val) {
        this.$emit("on-close");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.adt_modal {
  border-radius: 0;
  height: 100%;
  margin: 0 0 0 auto;
  max-width: 40%;
  overflow: auto;

  @media (max-width: 992px) {
    max-width: 70%;
  }

  @media (max-width: 500px) {
    max-width: 90%;
  }
}

.adt_modal-button {
  margin-left: 20px;
  margin-bottom: 20px;
}

.adt_modal-header {
  margin-left: 20px;
  margin-top: 35px;
}
.adt_heading-4 {
  font-weight: bold;
  color: var(--primary-color);
  margin-bottom: 10px;
}

.adt_modal-close {
  display: flex;

  .close-button {
    padding-left: 20px;
    padding-top: 5px;
  }
}

.grey-box {
  padding: 20px;
  border-radius: 5px;
  background-color: var(--bs-gray-200);
}

.slide-leave-active,
.slide-enter-active {
  transition: 0.8s;
}
.slide-enter {
  transform: translate(100%, 0);
}
.slide-leave-to {
  transform: translate(100%, 0);
}

.adt_modal-content {
  display: block;
  gap: 20px;
}

hr {
  height: 2px;
  color: var(--bs-gray-400);
}
</style>
